import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { SnackbarProvider } from './providers/SnackbarProvider';
import { ConfirmationDialogProvider } from './providers/ConfirmationDialogProvider';
import { PromptDialogProvider } from './providers/PromptDialogProvider';
import { Beforeunload } from 'react-beforeunload'
import './fonts/Montserrat/static/Montserrat-Regular.ttf'

ReactDOM.render(
  <React.StrictMode>
    <SnackbarProvider>
      <ConfirmationDialogProvider>
        <PromptDialogProvider>
          <App />
        </PromptDialogProvider>
      </ConfirmationDialogProvider>
    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
